import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import * as Icon from "react-bootstrap-icons";
import { UserContext } from "../../context/UserContext";
import Sidebar from "../../components/Admin/Sidebar";
import { useNavigate } from "react-router-dom";

const ReportPage = () => {
    const [hierarchyData, setHierarchyData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [toggleValue, setToggleValue] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searching, setSearching] = useState(false);
    const [debounceTimer, setDebounceTimer] = useState(null);

    const auth = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        fetchHierarchyData();
    }, []);

    useEffect(() => {
        if (selectedUser) {
            const filtered = hierarchyData.filter(item => item.user === selectedUser);
            setFilteredData(filtered);
        } else {
            setFilteredData(hierarchyData);
        }
    }, [selectedUser, hierarchyData]);

    useEffect(() => {
        return () => {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
            }
        };
    }, [debounceTimer]);

    const authtoken = localStorage.getItem("token");
    const token = `Bearer ${authtoken}`;

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        
        if (value) {
            setSearching(true);
            const timer = setTimeout(() => {
                setSearching(false);
            }, 500);
            setDebounceTimer(timer);
        } else {
            setSearching(false);
        }
    };

    const fetchHierarchyData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}userinfo/tree`,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );
            const treeData = response.data;
            const flatData = flattenTreeData(treeData);
            setHierarchyData(flatData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching hierarchy data:", error);
            setLoading(false);
        }
    };

    const flattenTreeData = (node) => {
        const result = [];
        const userMap = new Map();

        const collectChildren = (currentNode) => {
            const children = [];
            const traverse = (node) => {
                if (node) {
                    children.push(node.name);
                    if (node.left_child) traverse(node.left_child);
                    if (node.right_child) traverse(node.right_child);
                }
            };
            if (currentNode) traverse(currentNode);
            return children;
        };

        const traverse = (currentNode) => {
            if (currentNode) {
                const leftChildren = currentNode.left_child ? collectChildren(currentNode.left_child) : [];
                const rightChildren = currentNode.right_child ? collectChildren(currentNode.right_child) : [];

                const userData = {
                    user: currentNode.name,
                    leftChildren: leftChildren,
                    rightChildren: rightChildren,
                    referralCode: currentNode.referral_code || "N/A"
                };

                userMap.set(currentNode.name, userData);

                if (currentNode.left_child) {
                    traverse(currentNode.left_child);
                }
                if (currentNode.right_child) {
                    traverse(currentNode.right_child);
                }
            }
        };

        traverse(node);
        return Array.from(userMap.values());
    };

    // Check if user is admin
    if (auth?.user?.userType !== "admin") {
        return (
            <div className="container-fluid">
                <div className="row justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <div className="col-md-6 text-center">
                        <h3>Access Denied</h3>
                        <p>Only administrators can access this page.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2 p-0">
                    <Sidebar
                        toggleSidebar={toggleValue}
                        setToggleValue={setToggleValue}
                    />
                </div>

                <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
                    <Icon.ArrowRight
                        onClick={() => setToggleValue(true)}
                        className="my-5 sidebar-open"
                        color="black"
                        size={30}
                    />

                    <div className="row dashboard-content p-4">
                        <div className="col-12">
                            <h2 className="mb-4">User Hierarchy Report</h2>



                            {loading ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive shadow-sm">
                                        <table className="table table-striped table-hover mb-0" style={{ backgroundColor: '#fff' }}>
                                            <thead style={{ backgroundColor: '#2c3e50', color: 'white' }}>
                                                <tr>
                                                    <th className="py-3 px-4" style={{ fontWeight: '600', fontSize: '0.95rem' }}>
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-lg"
                                                                placeholder="Search users..."
                                                                value={searchTerm}
                                                                onChange={handleSearchChange}
                                                                onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                                            />
                                                            {searchTerm && (
                                                                <div className="dropdown-menu show position-absolute w-100" style={{ zIndex: 1000 }}>
                                                                    {searching ? (
                                                                        <div className="dropdown-item text-center">
                                                                            <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                                                            Searching...
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div
                                                                                className="dropdown-item"
                                                                                onClick={() => {
                                                                                    setSelectedUser("");
                                                                                    setSearchTerm("");
                                                                                    setShowDropdown(false);
                                                                                }}
                                                                            >
                                                                                All Users
                                                                            </div>
                                                                            {(() => {
                                                                                const filtered = hierarchyData.filter(item => item.user.toLowerCase().includes(searchTerm.toLowerCase()));
                                                                                return filtered.length > 0 ? (
                                                                                    filtered.map((item, index) => (
                                                                                        <div
                                                                                            key={index}
                                                                                            className="dropdown-item"
                                                                                            onClick={() => {
                                                                                                setSelectedUser(item.user);
                                                                                                setSearchTerm(item.user);
                                                                                                setShowDropdown(false);
                                                                                            }}
                                                                                        >
                                                                                            {item.user}
                                                                                        </div>
                                                                                    ))
                                                                                ) : (
                                                                                    <div className="dropdown-item text-muted text-center">
                                                                                        No users found
                                                                                    </div>
                                                                                );
                                                                            })()
                                                                            }
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="py-3 px-4" style={{ fontWeight: '600', fontSize: '0.95rem' }}>Left Team</th>
                                                    <th className="py-3 px-4" style={{ fontWeight: '600', fontSize: '0.95rem' }}>Right Team</th>
                                                    <th className="py-3 px-4" style={{ fontWeight: '600', fontSize: '0.95rem' }}>Referral Code</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredData.length > 0 ? (
                                                    filteredData.map((item, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #e9ecef' }}>
                                                            <td className="py-3 px-4">
                                                                <div className="d-flex align-items-center">
                                                                    {/* Mini tree */}
                                                                    <div className="mini-tree-widget">
                                                                        <svg width="160" height="100" viewBox="0 0 160 100">
                                                                            <g>
                                                                                {/* Center Node */}
                                                                                <circle cx="80" cy="50" r="16" fill="#2c3e50" />
                                                                                <text
                                                                                    x="80"
                                                                                    y="52"
                                                                                    textAnchor="middle"
                                                                                    dominantBaseline="middle"
                                                                                    fill="white"
                                                                                    fontSize="20"
                                                                                    fontWeight="bold"
                                                                                >
                                                                                    {item.user.charAt(0)}
                                                                                </text>

                                                                                {/* Left Line + Node */}
                                                                                <line x1="64" y1="50" x2="30" y2="80" stroke="#28a745" strokeWidth="3" />
                                                                                <circle
                                                                                    cx="30"
                                                                                    cy="80"
                                                                                    r="12"
                                                                                    fill="#28a745"
                                                                                    style={{ cursor: item.leftChildren.length > 0 ? "pointer" : "default" }}
                                                                                    onClick={() =>
                                                                                        item.leftChildren.length > 0 &&
                                                                                        navigate(`/admin/tree-view/${item.user}/left`)
                                                                                    }
                                                                                />
                                                                                <text
                                                                                    x="30"
                                                                                    y="85"
                                                                                    textAnchor="middle"
                                                                                    fill="white"
                                                                                    fontSize="14"
                                                                                    fontWeight="bold"
                                                                                    style={{ userSelect: "none", pointerEvents: "none" }}
                                                                                >
                                                                                    {item.leftChildren.length}
                                                                                </text>

                                                                                {/* Right Line + Node */}
                                                                                <line x1="96" y1="50" x2="130" y2="80" stroke="#17a2b8" strokeWidth="3" />
                                                                                <circle
                                                                                    cx="130"
                                                                                    cy="80"
                                                                                    r="12"
                                                                                    fill="#17a2b8"
                                                                                    style={{ cursor: item.rightChildren.length > 0 ? "pointer" : "default" }}
                                                                                    onClick={() =>
                                                                                        item.rightChildren.length > 0 &&
                                                                                        navigate(`/admin/tree-view/${item.user}/right`)
                                                                                    }
                                                                                />
                                                                                <text
                                                                                    x="130"
                                                                                    y="85"
                                                                                    textAnchor="middle"
                                                                                    fill="white"
                                                                                    fontSize="14"
                                                                                    fontWeight="bold"
                                                                                    style={{ userSelect: "none", pointerEvents: "none" }}
                                                                                >
                                                                                    {item.rightChildren.length}
                                                                                </text>
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                    {/* Mini tree */}
                                                                    <div className="me-3">
                                                                        <div style={{ fontWeight: '600', fontSize: '1rem', color: '#2c3e50' }}>{item.user}</div>
                                                                        <small className="text-muted">Active User</small>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="py-3 px-4">
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <span className="badge bg-success me-2" style={{ fontSize: '0.75rem' }}>
                                                                            {item.leftChildren.length}
                                                                        </span>
                                                                        <span style={{ fontSize: '0.9rem', color: '#495057' }}>Members</span>
                                                                    </div>
                                                                </div>
                                                                {item.leftChildren.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <ul className="list-unstyled mb-0" style={{ maxHeight: item.leftChildren.length > 5 ? '120px' : 'auto', overflowY: item.leftChildren.length > 5 ? 'auto' : 'visible', fontSize: '0.85rem' }}>
                                                                            {item.leftChildren.map((child, idx) => (
                                                                                <li key={idx} className="d-flex align-items-center py-1" style={{ borderBottom: idx < item.leftChildren.length - 1 ? '1px solid #f1f3f4' : 'none' }}>
                                                                                    <div className="bg-success rounded-circle me-2" style={{ width: '6px', height: '6px' }}></div>
                                                                                    <small style={{ color: '#495057' }}>{child}</small>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="py-3 px-4">
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <span className="badge bg-info me-2" style={{ fontSize: '0.75rem' }}>
                                                                            {item.rightChildren.length}
                                                                        </span>
                                                                        <span style={{ fontSize: '0.9rem', color: '#495057' }}>Members</span>
                                                                    </div>
                                                                </div>
                                                                {item.rightChildren.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <ul className="list-unstyled mb-0" style={{ maxHeight: item.rightChildren.length > 5 ? '120px' : 'auto', overflowY: item.rightChildren.length > 5 ? 'auto' : 'visible', fontSize: '0.85rem' }}>
                                                                            {item.rightChildren.map((child, idx) => (
                                                                                <li key={idx} className="d-flex align-items-center py-1" style={{ borderBottom: idx < item.rightChildren.length - 1 ? '1px solid #f1f3f4' : 'none' }}>
                                                                                    <div className="bg-info rounded-circle me-2" style={{ width: '6px', height: '6px' }}></div>
                                                                                    <small style={{ color: '#495057' }}>{child}</small>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="py-3 px-4">
                                                                <div className="d-flex align-items-center">
                                                                    <Icon.QrCode className="me-2 text-muted" size={16} />
                                                                    <code style={{ backgroundColor: '#f8f9fa', padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem' }}>
                                                                        {item.referralCode}
                                                                    </code>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4" className="text-center py-5">
                                                            <div className="text-muted">
                                                                <Icon.PersonX size={48} className="mb-3" />
                                                                <div style={{ fontSize: '1.1rem' }}>No users found</div>
                                                                <small>Try adjusting your search criteria</small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportPage;